export default __webpack_public_path__ + "static/media/slider-why-laptop-image3.e7e5b73e.jpg";